import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import "antd/dist/antd.css";
import "../../Assets/Styles/pages/signature.scss";

import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import "../../Assets/Styles/pages/dateTime.scss";
import { setItem } from "../../Redux/WaterMarks/wateramarks";
import CancelButton from "../Cancel_button/Cancel_button";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ButtonRounded from "../Signature/button";
const AddText = ({ open, setOpen, setActive }) => {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const [font, setFont] = useState("Arial");
  const [color, setColor] = useState("#000000");
  const [shadowColor, setShadowColor] = useState("#000000");
  const [enableShadowColor, setEnableShadowColor] = useState("#000000");
  const dispatch = useDispatch();

  const previoiusState = useSelector((state) => state["previousSettingsSlice"]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  useEffect(() => {
    setFont(previoiusState.textFont);
    setColor(previoiusState.textColor);
    setShadowColor(previoiusState.shadowColor);
    setEnableShadowColor(previoiusState.enableshadowColor);
  }, [previoiusState]);

  const applyText = () => {
    if (text !== null && text !== "") {
      dispatch(
        setItem({
          type: "text",
          property: "text",
          id: Date.now(),
          x: 50,
          y: 50,
          deg: 0,
          scaleX: 0.15,
          scaleY: 0.15,
          src: text,
          opacity: 1,
          textColor: color,
          font: font,
          shadowColor: shadowColor,
          enableShadowColor: enableShadowColor,
          textAlign: "left",
          multiLine: isChecked,
        })
      );
      setText("");
      setOpen(false);
      setActive("text");
    } else {
      setText("");
      setOpen(false);
      setActive("");
    }
  };
  return (
    <Modal
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
      onClose={() => setOpen(false)}
    >
      <Fade in={open}>
        <div className="text_model date_model p-4">
          <CancelButton close={() => setOpen(false)} />
          <Col className="border-bottom">
            <p className="text_center productSansBold text_18 line_height_100pc mt-0  mb-0">
              {t("AddText.AddText")}
            </p>
            <p className="text_center productSansLight text_15  mt-2 ">
              {t("AddText.Subtitle")}
            </p>
          </Col>
          <Col className="productSansLight text_15 pt-3 px-3 m-0 p-0 d-flex flex-column align-items-start">
            <Row className="w-100 m-0">
              <Form.Group className="mb-3 p-0">
                <Form.Label>{"Enter Text"}</Form.Label>
                <Form.Control
                  as={isChecked ? "textarea" : "input"}
                  rows={2}
                  size="small"
                  className="add_text_box"
                  onChange={(e) => {
                    e.preventDefault();
                    setText(e.target.value);
                  }}
                  type="text"
                  value={text}
                  placeholder={t("ImageProps.TypeText")}
                />
              </Form.Group>
            </Row>
            <Row className="m-0">
              <Form.Check
                type="checkbox"
                label={t("AddText.Multiline")}
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </Row>
            {/* {<Row className="d-flex justify-content-center text-white">
              <Button
                variant="contained"
                className="date_button mt-4 text_19 CamptonLight"
                onClick={applyText}
              >
                {t("Nav.Apply")}
              </Button>
            </Row>} */}
            <ButtonRounded
              onclick={applyText}
              text={"Nav.Apply"}
              style={"w_edit_button  mt-3 mb-1"}
              parrentStyle={"w-100"}
            />
          </Col>
        </div>
      </Fade>
    </Modal>
  );
};

export default AddText;
